var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78033 3.96967C8.48744 3.67678 8.01256 3.67678 7.71967 3.96967C7.42678 4.26256 7.42678 4.73744 7.71967 5.03033L8.78033 3.96967ZM15.75 12L16.2803 12.5303C16.5732 12.2374 16.5732 11.7626 16.2803 11.4697L15.75 12ZM7.71967 18.9697C7.42678 19.2626 7.42678 19.7374 7.71967 20.0303C8.01256 20.3232 8.48744 20.3232 8.78033 20.0303L7.71967 18.9697ZM7.71967 5.03033L15.2197 12.5303L16.2803 11.4697L8.78033 3.96967L7.71967 5.03033ZM15.2197 11.4697L7.71967 18.9697L8.78033 20.0303L16.2803 12.5303L15.2197 11.4697Z",
    fill: "#current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightCom);
export default __webpack_public_path__ + "static/media/arrow_right_com.0466761af129ab9286d648e2dc95b986.svg";
export { ForwardRef as ReactComponent };